import React, {PropTypes} from 'react';

// https://stackoverflow.com/questions/39761443/how-to-dispatch-redux-action-from-stateless-component-when-route-is-loaded
const onMount = (onMountFn) => (Component) => React.createClass({
   componentDidMount() {
     onMountFn(this.props);
   },
   render() {
      return <Component {...this.props} />
   }
});

export default onMount



// WEBPACK FOOTER //
// ./src/core/onMount.js